module.exports = __webpack_public_path__ + "img/paragraph.05409f66.svg";